import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles/index';

import TerminalsContainer from '../../containers/logistics/Terminals';

const styles = () => {
	return {
		product: {
			paddingLeft: 10,
			fontSize: 14,
			color: '#666',
			fontWeight: 100,
		},
		loading: {
			fontSize: 11,
			lineHeight: '11px',
			color: '#777',
		},
		margin: {
			margin: '5px 0px',
		},
	};
};

class FMPTerminalPicker extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			terminalId: '',
		};
	}

	componentDidMount() {
		const { terminals, searchTerminals } = this.props;

		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
	}

	render() {
		const {
			label,
			value,
			path,
			onChange,
			terminals,
			productTypes,
			error,
			helpText,
			md,
			justBulk,
			noFilter,
			contained,
		} = this.props;

		const hasError = !!error;
		const _onChange = (event) => {
			onChange(event.target.value, path);
		};

		let terminalsWithProduct = [];
		if (noFilter) {
			terminalsWithProduct = terminals;
		} else {
			const supplierAttribute = justBulk ? 'bulkSuppliers' : 'supplierProducts';
			const productTypeMap = _.keyBy(productTypes);
			terminalsWithProduct = _.filter(terminals, (terminal) => {
				if (!terminal[supplierAttribute]) {
					return false;
				}
				return _.some(terminal[supplierAttribute], (sp) => {
					return productTypeMap[sp.product];
				});
			});
		}

		terminalsWithProduct = _.sortBy(terminalsWithProduct, 'name');
		const content = (
			<Grid item xs={12} md={md}>
				<FormControl fullWidth={true} error={!!error}>
					<InputLabel>{label}</InputLabel>
					<Select value={value} onChange={_onChange} input={<Input />}>
						{terminalsWithProduct.map((terminal) => {
							const { terminalId, name } = terminal;
							return (
								<MenuItem key={terminalId} value={terminalId}>
									{name}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPTerminalPicker.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	searchTerminals: PropTypes.func.isRequired,
	terminals: PropTypes.array,

	productTypes: PropTypes.array,
	contained: PropTypes.bool,

	justBulk: PropTypes.bool,
	noFilter: PropTypes.bool,
	md: PropTypes.number,
	helpText: PropTypes.string,
};

FMPTerminalPicker.defaultProps = {
	justBulk: false,
	noFilter: false,
	md: 12,
	contained: true,
};

export default _.flow([withStyles(styles), TerminalsContainer])(FMPTerminalPicker);
